export default {
  "open": "Ingrandisci immagine buca {number}",
  "title": "{course} · Hole {number} immagine",
  "back": "Torna a segnare",
  "hole": "Buca {number}",
  "description": "{course} · buca {number}",
  "loading": "Caricamento immagine...",
  "error": "Questa immagine non poteva essere caricata.",
  "retry": "Riprova",
  "zoom": "zoom immagine",
  "out": "Zoom fuori",
  "reset": "Ripristina lo zoom",
  "in": "Ingrandisci"
}
